import React, { useState, useEffect } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import { useSelector, useDispatch } from "react-redux";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useLocation } from "react-router-dom";
import { sessiondata } from "../../assets/Griddata"; // Import dataset
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { USERS_API_06, USERS_API_09, USERS_API_10 } from "../../api/ApiModel";
import Snackbar from "@mui/material/Snackbar";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Alert from "@mui/material/Alert";
function UpdateSession() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const location = useLocation();
  const { userRefCode, username } = location.state || {};
  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  console.log("userRefCode", userRefCode);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const gotToPage = () => {
    navigate("/ViewUsers");
  };
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, EXPDATE, STS } = SYS_USER.USER_PARAM || {};

  const handleSearchChange = (event) => {
    // Update searchText when typing in TextField
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchUpdatesessionData = async () => {
    try {
      const result = await externalgetApi(USERS_API_09, "get", {
        USERREFCODE: userRefCode || "",
      });
      setData(result);
      console.log("result fetchUserLogData", result);
      setFilteredRows(result);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const rows = filteredRows
    ? filteredRows.map((item, index) => ({
        id: index + 1,
        USERNAME: item.USERNAME,
        ENDATE: item.ENDATE,
        LOGSTS: item.LOGSTS,
      }))
    : [];

  useEffect(() => {
    fetchUpdatesessionData();
  }, []);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleClearSession = async () => {
    try {
      await externalpostApi(USERS_API_10, {
        compcode: COMPCODE,
        userrefcode: String(userRefCode),
        username: username,
      });
      setSnackbarMessage("Session cleared successfully!");
      setOpenSnackbar(true);
    } catch (err) {
      console.error("Error clearing session:", err);
      setSnackbarMessage("Error clearing session.");
      setOpenSnackbar(true);
    }
  };
  const menuItems = [
    {
      text: "Clear Session",
      icon: <RestartAltIcon />,
      onClick: handleClearSession,
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">Sessions</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          // columns={sessiondata.columns}

          columns={sessiondata?.columns || []}
          rows={rows}
          menuItems={menuItems}
          // tabletitle={sessiondata.name}

          tabletitle={`User Logs: ${username || "Unknown User"}`}
          gridid="USERREFCODE"
        />
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default UpdateSession;
